import Styles from "./Loading.module.scss";
import clsx from "clsx";
import { RiseLoader } from "react-spinners";
function Loading() {
  return (
    <div className={clsx(Styles.loadingWrap)}>
      <RiseLoader color={"#2d6b5f"} loading={true} speedMultiplier={1.5} />
    </div>
  );
}
export default Loading;
